// Shared async selector capability – i18n manifest (veřejný kontrakt pro composition)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'asyncSelector';

export const asyncSelectorI18nManifest: SliceI18nManifest = {
  owner: 'shared/ui/async-selector',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
